import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { uiText } from "@/lib/i18n/uiText";

/** Pull "2-1" out of a graded outcome text like "2-1 (HT 0-0)" as a fallback. */
function scoreFromOutcome(text?: string | null): string | null {
  const m = text?.match(/^\s*(\d{1,2})\s*-\s*(\d{1,2})\b/);
  return m ? `${m[1]} - ${m[2]}` : null;
}

/** Final result chip ("FT 2 - 1") shown on a prediction card once it is graded. */
export function FinalScore({ matchId, actualOutcome, graded }: { matchId?: string | null | undefined; actualOutcome?: string | null | undefined; graded: boolean }) {
  const { data } = useQuery({
    queryKey: ["final-score", matchId],
    enabled: graded && !!matchId,
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const { data } = await supabase
        .from("matches_public")
        .select("home_score, away_score")
        .eq("id", matchId!)
        .maybeSingle();
      return data;
    },
  });
  if (!graded) return null;
  const score =
    data?.home_score != null && data?.away_score != null
      ? `${data.home_score} - ${data.away_score}`
      : scoreFromOutcome(actualOutcome);
  if (!score) return null;
  return (
    <Badge variant="outline" className="font-mono tabular-nums" aria-label={uiText("Final result")}>
      {uiText("FT")} {score}
    </Badge>
  );
}
